import React from 'react';
import { resourceBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';
import ActionConfirmationDialog from './Components/ActionConfirmationDialog';
import DialogCardContainer from './Components/DialogCardContainer';
import DialogHeader from './Components/DialogHeader';
import InterviewConfirmDialogBody from './Components/InterviewConfirm/InterviewConfirmDialogBody';
import InterviewConfirmDialogHeader from './Components/InterviewConfirm/InterviewConfirmDialogHeader';
import { DialogEnum, useActionDialogContext } from './Context/ActionDialogContext';
import { Button, Spinner } from '@/Components/shadcn';

function InviteForInterviewConfirm(): React.JSX.Element {
    const {
        selectedCandidates,
        showInviteForInterviewNotification,
        hideDialog,
        inviteForInterviewApplicantAsync,
        isInviteForInterviewLoading,
    } = useActionDialogContext();

    const closeConfirm = () => {
        hideDialog(DialogEnum.InviteForInterviewConfirm);
    };

    const candidate = selectedCandidates[0];

    return (
        <ActionConfirmationDialog
            dialogType={DialogEnum.InviteForInterviewConfirm}
            header={<DialogHeader title={UIStrings.InviteForInterview} badgeClassName="bg-primary" />}
            body={
                <DialogCardContainer
                    className="h-fit"
                    dialogTitle={<InterviewConfirmDialogHeader name={candidate?.name} />}
                    dialogBody={<InterviewConfirmDialogBody name={candidate?.name} />}
                    icon={
                        <img
                            src={`${resourceBaseUrl}/images/ATSMarkInterviewing.png`}
                            className="h-auto w-3xl"
                            alt="interview"
                        />
                    }
                />
            }
            actions={
                <Button
                    className="w-full"
                    size="lg"
                    variant="default"
                    disabled={isInviteForInterviewLoading}
                    onClick={async () => {
                        await inviteForInterviewApplicantAsync();
                        closeConfirm();
                        showInviteForInterviewNotification();
                    }}
                >
                    {isInviteForInterviewLoading && <Spinner data-icon="inline-start" />}
                    {UIStrings.MarkAsInviteForInterview}
                </Button>
            }
        />
    );
}

export default InviteForInterviewConfirm;
